<template>
    <div class="page_container" v-loading="loading">
        <div class="from_box">
          <h5>系统维护后台控制</h5>
          <el-form :model="scriptForm"  :rules="scriptFormRules"  label-position="top"   ref="scriptForm"   size="small">
            <el-form-item label="提示语 " prop="notice">
              <el-input  placeholder="请输入"  v-model="scriptForm.notice" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="时间" prop="time">
              <el-date-picker   end-placeholder="请输入结束时间"
                                start-placeholder="请输入开始时间"
                                format="yyyy-MM-dd HH:mm"
                                range-separator="-" type="datetimerange"  v-model="scriptForm.time" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
            </el-form-item>
            <el-form-item label="白名单人员" prop="white_uids">
              <el-select  :remote-method="getUserList"  multiple  filterable placeholder="请选择"   remote reserve-keyword  v-model="scriptForm.white_uids">
                <el-option  v-for="(item,index) in userList" :key="item.user_id"   :label="item.name"   :value="item.user_id" > </el-option>
              </el-select>
            </el-form-item>
            <div style="text-align: right;">
              <el-button :disabled="btnDisabled" @click="handleClickConfirm" size="small" type="primary">提交</el-button>
            </div>
          </el-form>
        </div>

    </div>
</template>
<script>
    import {addUpgrade, getUpgrade,CompanyUserList} from "@/api";
    export default {
        name: "upgrade",
        data() {
            return {
                loading: false,
                scriptForm:{
                  notice:'',
                  time:[],
                  white_uids:[]
                },
                scriptFormRules: {

                },
                btnDisabled:false,
                userList:[]
            }
        },
        components: { },
        created() {
          this.getUpgrade()
          this.getUserList()
        },
        mounted() {
        },
        methods: {
          getUserList(name){
            CompanyUserList({
              company_id: 1,
              name: name,
              page: 1,
              pageSize: 1500,
            }).then(res => {
              if (res.code === 200) {
                const { data, total  } = res.data
                this.userList = data
              }
              this.loading = false
            })
          },

          getUpgrade(){
            this.loading = true
            getUpgrade({ }).then(res => {
              const {data} = res.data
              if(data != null){
                this.scriptForm.notice = data.notice
                this.scriptForm.time = data.start_time  ? [data.start_time,data.end_time] : []
                this.scriptForm.white_uids =  data.white_uids
              }else{

              }
              this.loading = false
            }).catch(()=>{
              this.loading = false
            })

          },
          handleClickConfirm(){
            this.$refs.scriptForm.validate(valid => {
              if (valid) {
                this.$confirm('确定开启系统维护吗？', '提示', {
                  confirmButtonText: '提交',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {

                  addUpgrade({
                    notice:this.scriptForm.notice,
                    start_time:this.scriptForm.time ? this.scriptForm.time[0] : '',
                    end_time:this.scriptForm.time ?  this.scriptForm.time[1] :'',
                    white_uids:this.scriptForm.white_uids,
                  }).then(res => {
                    this.$message.success('设置成功')
                    this.loading = false
                  }).catch(()=>{
                    this.$message.error(res.message)
                    this.loading = false
                  })


                }).catch(() => {

                });
              }
            })
          },




        },
    }
</script>
<style lang="scss" scoped>

  .from_box{
    max-width: 500px;
    margin: 0 auto;
    padding: 100px 20px;
    box-sizing: border-box;
  }
  .from_box h5{
    text-align: center;
    line-height: 60px;
    color: #000;
    font-size: 16px;
    font-weight: bold;
  }
  .el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner{
    width: 100% !important;
  }

  .version_content_wrap{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
